import React, { useState, useEffect, useRef } from "react";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from 'primereact/inputtextarea';
import "../clap/FormulaireClap.scss";
import { InputText } from 'primereact/inputtext';
import { useSelector } from "react-redux";
import { FieldBuilder } from "./../fields/FieldBuilder";
import { Toast } from "primereact/toast";
import { FileService } from "../../../service/FileService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import { Calendar } from 'primereact/calendar';
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';
import { ExerciceService } from "../../../service/ExerciceService";
import { ClapService } from "../../../service/ClapService";
import { Transform } from "superagent/lib/node/response";
import { RibService } from "../../../service/RibService";

export const FormulaireChangementRib = ({mode, oldForm}) => {
    const createMode = 'create';
    const editMode = 'edit';

    const usager = useSelector((state) => state.usager.user);
    const actionSociale = useSelector((state) => state.actionSociale);

    const ribService = new RibService();

    const [mapping, setMapping] = useState([]);
    const [enfants, setEnfants] = useState(actionSociale.enfants);
    const [currentEnfant, setCurrentEnfant] = useState();
    const [currentActionSociale, setCurrentActionSociale] = useState({});

    const [selectedEnfant, setSelectedEnfant] = useState(null);
    const [dateRange, setDateRange] = useState([])
    const [montantFrais, setMontantFrais] = useState();

    const [justificatifEnfant, setJustificatifEnfant] = useState([]);
    const [justificatifPresence, setJustificatifPresence] = useState([]);

    const [justificatifIban, setJustificatifIban] = useState([]);
    const [justificatifId, setJustificatifId] = useState([]);

    const [retourJustificatifIban, setRetourJustificatifIban] = useState(false);
    const [retourJustificatifEnfant, setRetourJustificatifEnfant] = useState(false);
    
    const [retourJustificatifPresence, setRetourJustificatifPresence] = useState(false);
    const [justificatifSupplementInformations, setJustificatifSupplementInformations] = useState([]);

    const [recapEnfant, setRecapEnfant] = useState('');

    const [policyOne, setPolicyOne] = useState(false);
    const [policyTwo, setPolicyTwo] = useState(false);
    const [checkTitulaire, setCheckTitulaire] = useState(true);

    const [displayBasic, setDisplayBasic] = useState(false);
    const [showFileUploadError, setShowFileUploadError] = useState(false);
    const [showDemandeError, setShowDemandeError] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [disabled2, setDisabled2] = useState(false);

    const [codeError, setCodeError] = useState(false);

    const [step, setStep] = useState(0);
    const [activeIndex, setActiveIndex] = useState([]);

    const actionSocialeService = new ActionSocialeService();
    const fileService = new FileService();
    const chequeCultureService = new ChequeCultureService();
    const linkService = new LinkProviderService();
    const exerciceService = new ExerciceService();
    const clapService = new ClapService();



    const [iban, setIban] = useState(null);
    const [id, setId] = useState(null);

    const [ibanNotFransh, setIbanNotFransh] = useState(false);
    const [isIbanValide, setIsIbanValide] = useState(false);
    const [editCategoryJustif, setEditCategoryJustif] = useState(null);
    const [editIbanJustif, setEditIbanJustif] = useState(null);
    const [ibanMembre, setIbanMembre] = useState(null);

    const [editFormData, setEditFormData] = useState(null);

    const inputRef = useRef(null);
    const cursorPositionRef = useRef(null);




    const toast = useRef(null);


    const editJustificatifMsg = 'Merci de renvoyer un document conforme.'

    const text =<div><p>Politique de protection des données à caractère personnel</p>
        <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
        <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
       <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
        <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
        <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
        <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>


    const mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

    const descriptionCategorie23="Document de la banque où sont indiquées les coordonnées du compte au format IBAN et mon nom comme titulaire du compte.";



    const justificatifsCategories3 = [
        { "key": "059", "value": "Justificatif de présence en établissement" ,"description":"Le document doit dater de moins d'un mois"}
    ];

    const justificatifsCategoriesSupplement = [
        { "key": "999", "value": "Document complémentaire demandé par le C.G.O.S" ,"description":""}
    ];

    const justificatifsIBAN = [  //Justificatif pour l'iban
        { "key": "003", "value": "Relevé d'identité bancaire" ,"description":descriptionCategorie23},
    ];




    const handleFilesError = (error) => {
           if(error.response === undefined){
            displayErrorFile('Un des fichiers parmi vos justificatifs est endommagé, il ne peut pas être utilisé.\nRéparez ou remplacez le fichier et réessayez.')
           }else{
                localStorage.setItem("errorMessage", error.response.data.message)
                window.location ="/#/serviceIndisponible/FH-" + error.response.data.errorId;
           }
        }


    
    useEffect(() => {
        if (editMode === mode) {
            fetchDataForEdition();
        }
        getIbanMembre();
        exerciceService.getExerciceEnCours();
        initActiveIndex();
    }, []);

    const getIbanMembre = async () => {
        try {
          const { data } = await clapService.getIbanMembre(usager.numCgos);
          setIbanMembre(data.numIBan);
        } catch (error) {
          console.log("error loading old iban")
        }
     };




    useEffect(() => {
        setActiveIndex(prevState => [...prevState, step]);
    },[step]);



    const fetchDataForEdition = async() => {
        chequeCultureService.getEditDto().then((form) => {
                setEditFormData(form.data)
                let jsonObj = JSON.parse(form.data.formJson);
                 setId(jsonObj.FORMULAIRE[0].VALEUR);
                 //setSelectedEnfant(parseInt(jsonObj.FORMULAIRE[0].VALEUR));jsonObj.FORMULAIRE[1].VALEUR
                setIban(jsonObj.FORMULAIRE[1].VALEUR);
                Object.values(form.data.filesToUpload).forEach(file => {
                    if(actionSociale.cas =="CHGT1"){
                        setEditIbanJustif(justificatifsIBAN.find(e => e.key === file.codeJustificatif));
                        //setEditCategoryJustif(justificatifsCategoriesAdult.find(e => e.key === file.codeJustificatif));
                    }
                });

         });
    };







    const initActiveIndex = () => {
        if(createMode === mode) setActiveIndex([step]);
        if(editMode === mode) setActiveIndex([0,1,2,3,4]);
    };

    const nextStep = (e, increment) => {
        e.target.disabled = true;
        e.target.classList.add("disabled");
        e.target.style.pointerEvents = "none";
        e.target.style.display = "none";
        setStep(step + increment);
    };

    const disableSubmitCreate = () => {
        if(actionSociale.optJustificatif)
            return (!(justificatifIban) || !policyOne || !policyTwo || !checkTitulaire ||disabled) ;
        else
            return (!(justificatifIban) || !policyOne || !policyTwo || !checkTitulaire || disabled) ;
    };

    const disableSubmitEdit = () => {
        if(actionSociale.optJustificatif)
            return ((!justificatifIban && justificatifIban.length >= 1) || !policyOne || !policyTwo || disabled) ;
        else
            return ((!justificatifIban && justificatifIban.length >= 1) || !policyOne || !policyTwo || disabled) ;
    };

    const submitFormDemande = async (e) => {
        e.preventDefault();

        //on mes des espace a iban
        const newIban = ibanNotFransh?"FR76 9999 9999 9999 9999 9999 944":iban.replace(/(.{4})/g, '$1 ').trim();
        const nomTitulaire = ibanNotFransh ? "RIB ETRANGER" : id;
        if(e.detail == 1){
 
            const jsonFormSchema = {
                
                formulaire: [
                    {
                        "code": "NEA_NOM_TITULAIRE",
                        "valeur": nomTitulaire,
                    },
                    {
                        "code": "NEA_IBAN_TITULAIRE",
                        "valeur": newIban,
                    },
                    {
                        "code": "NEA_NOM_NAISSANCE",
                        "valeur": !usager.nomNaissance ? "" : usager.nomNaissance,
                    },
                ]
            };

            const demande = {
                etape: "1",
                exercice: localStorage.getItem('exerciceEnCours'),
                origine: "NEA",
                codeClasseur: "CHGT1",
                demandeStatutReferentiel: { id: 1 },
                demandeDetails: [],
            };
            
            const demandeDetail = {
                demandeType: {
                    codeActionSocial: "CHGT1",
                },
                formJson: JSON.stringify(jsonFormSchema).toUpperCase(),
                montant: montantFrais,
                version: "1",
            };

            demande.demandeDetails.push(demandeDetail);

            if((justificatifIban) || disabled2){

                setDisabled(true);

                let justificatifsPresenceList = [];
                let justificatifsPrestaList = [];
                let justificatifIbanList = [];

                if (justificatifIban && justificatifIban.length > 0) {
                    Object.values(justificatifIban).forEach(jus => {
                        justificatifIbanList.push(jus.category[1]);
                    });
                }

                const infosDemandeClapDto = {
                    "codeActionSociale": "CHGT1",
                    "dateNaissance": "",
                    "depenses": "",
                    "emailPersonnel": usager.email,
                    "exercice": localStorage.getItem('exerciceEnCours'),
                    "iban": newIban,
                    "justificatifsPresence": [],
                    "justificatifsPresta":[],
                    "justificatifsRib": justificatifIbanList,
                    "libelleActionSociale": "CHANGEMENT IBAN",
                    "nom": usager.nom,
                    "nomNaissance": usager.nomNaissance,
                    "nomEnfant": "",
                    "numCgos": usager.numCgos,
                    "periodeCouverte": "",
                    "positionStatutaire": "",
                    "prenom": usager.prenom,
                    "prenomEnfant": "",
                    "qf": "",
                    "situationAdministrative": "",
                    "etbLibelle": usager.libelleEtablissement,
                    "nomTitulaire": nomTitulaire,
                    "ibanMembre":ibanMembre.replace(/(.{4})/g, '$1 ').trim()
                };
                
                fileService
                    .uploadMultiFile(justificatifIban)
                    .then((res) => {
                        if (null != res.data && res.data != undefined) {
                            fileService.createRecaputilatifDemande(infosDemandeClapDto).then((response) => {
                                showInfo("Justificatif");
                                saveDemande(demande);
                            })
                            .catch((err) => {
                                handleFilesError(err);
                            }).finally(() => {
                                setDisabled(false);
                            });

                        } else {
                            setShowFileUploadError(true);
                        }
                    })
                    .catch((err) => {
                        handleFilesError(err);
                    }).finally(() => {
                        setDisabled(false);
                    });
            }
        }
    };


    const saveDemande = (demande) => {

        /*chequeCultureService
            .testPays(demande)
            .then((res) => {
                if(res.data == 1){*/
                    
                    chequeCultureService
                        .submitDemandeForm(demande)
                        .then((res) => {
                            setDisplayBasic(true);
                            showInfo("Demande");
                        })
                        .catch((err) => {
                            window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
                        });
                        
                /*}
                else{
                    displayError("Votre iban n'est pas valide, Merci de verifier le champ saisie, cocher iban etranger ci etranger")
                }
                
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });*/

    };

    // ============== NEW ============== //
    
    // constitution de la liste des justifs à uploader en cas ce complément d'info
    let libelleJustifToDisplay = [];
    let codeJustifToUploadList = []; 
    let cloneJustifToUploadList = [];
    
    if (editFormData != null && editFormData.filesToUpload != null && editFormData.filesToUpload.length > 0) {
        Object.values(editFormData.filesToUpload).forEach(file => {
             if(!codeJustifToUploadList.includes(file.codeJustificatif)){
                 codeJustifToUploadList.push(file.codeJustificatif);
             }            
             cloneJustifToUploadList.push(file.codeJustificatif);
             libelleJustifToDisplay.push(file.libelleJustificatifMotifSpecifique);
         });
         if(editFormData?.siSupplementInfo){
                     codeJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
                     cloneJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
         }
        libelleJustifToDisplay.push(editFormData.noteRetourAgent);
     }

     if(libelleJustifToDisplay.length === 0  && editFormData?.siSupplementInfo){
         if(editFormData?.siSupplementInfo){
                             codeJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
                             cloneJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
                 }
          libelleJustifToDisplay.push(editFormData.noteRetourAgent);
     }

     // ============== END NEW ============== //

    const submitEditedDemande = async(e) => {
        e.preventDefault();
        // On recupère les codes dans justificatifEnfant
        
        if(e.detail == 1){
            const jsonFormSchema = {
                formulaire: [
                    {
                        "code": "NEA_NOM_TITULAIRE",
                        "valeur": id,
                    },
                    {
                        "code": "NEA_IBAN_TITULAIRE",
                        "valeur": iban,
                    },
                    {
                        "code": "NEA_NOM_NAISSANCE",
                        "valeur":!usager.nomNaissance ? "" : usager.nomNaissance,
                    },
                ]
            };

        
            const demande = {
                montantTotal: montantFrais,
                demandeId: editFormData.demandeId,
                recordId: editFormData.recordId,
                filesToUpload: editFormData.filesToUpload,
                formJson: JSON.stringify(jsonFormSchema).toUpperCase(),
                codeActionSociale: editFormData.codeActionSociale,
                exercice: editFormData.exercice
            };


            if((justificatifIban)){

                setDisabled(true);

                let justificatifsPresenceList = [];
                let justificatifsPrestaList = [];
                let justificatifIbanList = [];

                if (justificatifIban && justificatifIban.length > 0) {
                    Object.values(justificatifIban).forEach(jus => {
                        justificatifIbanList.push(jus.category[1]);
                    });
                }

                const infosDemandeClapDto = {
                    "codeActionSociale": "CHGT1",
                    "dateNaissance": "",
                    "depenses": "",
                    "emailPersonnel": usager.email,
                    "exercice": editFormData.exercice,
                    "iban": iban,
                    "justificatifsPresence": [],
                    "justificatifsPresta":[],
                    "justificatifsRib": justificatifIbanList,
                    "libelleActionSociale": "CHANGEMENT IBAN",
                    "nom": usager.nom,
                    "nomNaissance": usager.nomNaissance,
                    "nomEnfant": "",
                    "numCgos": usager.numCgos,
                    "periodeCouverte": "",
                    "positionStatutaire": "",
                    "prenom": usager.prenom,
                    "prenomEnfant": "",
                    "qf": "",
                    "situationAdministrative": "",
                    "etbLibelle": usager.libelleEtablissement,
                    "nomTitulaire": id,
                    "ibanMembre":ibanMembre.replace(/(.{4})/g, '$1 ').trim()
                };
                let recordIds=editFormData.filesToUpload.map(file => file.recordId);
                let categories=editFormData.filesToUpload.map(file => file.codeJustificatif);
                if(recordIds?.length > 0){
                    fileService.uploadEditedFiles(justificatifIban.concat(justificatifSupplementInformations),recordIds,codeJustifToUploadList)
                                            .then((res) => {
                                                if (null != res.data && res.data != undefined) {
                                                    fileService.updateRecaputilatifDemande(infosDemandeClapDto, demande.demandeId).then((response) => {
                                                        showInfo("Justificatif");
                                                        saveEditedDemande(demande);
                                                    });
                                                } else {
                                                    setShowFileUploadError(true);
                                                }
                                            })
                                            .catch((err) => {
                                                handleFilesError(err);
                                            }).finally(() => {
                                            setDisabled(false);
                                            });
                }else if(editFormData?.siSupplementInfo){
                    fileService.uploadMultiFile(justificatifSupplementInformations)
                                             .then((res) => {
                                                  if (null != res.data && res.data != undefined) {
                                                      fileService.updateRecaputilatifDemande(infosDemandeClapDto, demande.demandeId).then((response) => {
                                                                            showInfo("Justificatif");
                                                                            saveEditedDemande(demande);
                                                                        });
                                                      } else {
                                                            setShowFileUploadError(true);
                                                      }
                                                             })
                                                      .catch((err) => {
                                                        handleFilesError(err);
                                                      }).finally(() => {
                                                        setDisabled(false);
                                                      });
                }

            }
        }
    };

    const saveEditedDemande = (demande) => {
        chequeCultureService
            .submitEditedForm(demande)
            .then((res) => {
                setDisplayBasic(true);
                showInfo("Demande");
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };


    const showInfo = (msg) => {
        toast.current.show({
            severity: "info",
            summary: "Succès",
            detail: msg + " envoyée avec succès. ",
            life: 5000,
        });
    };

    const displayError = (msg) => {
        toast.current.show({
            severity: "error",
            summary: "ERREUR",
            detail: msg,
            life: 5000,
        });
    };

    const displayErrorFile = (message) => {
                toast.current.show({
                    severity: "error",
                    summary: "ERREUR DE FICHIER",
                    detail: message,
                    life: 5000,
                });
            }

    const basicDialogFooter = (
        <Button
            type="button"
            label="RETOUR ESPACE AGENT"
            onClick={(e) => logoutRemoveData(e)}
            className="btn_submit_modal"
        />
    );



    const logoutRemoveData = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        handleAnnuler();
    };


    const handleAnnuler = () => {
        chequeCultureService.redirectEaLegacy();
    };

    const validateInputTitulaire = (event, validatePattern) => {
            const target = event.target;
            if (!target.value?.toLowerCase().includes(usager.nom.toLowerCase())  && !target.value?.toLowerCase().includes(usager.nomNaissance?.toLowerCase())) {
                        setCheckTitulaire(false);
                        return;
             }else{
                       setCheckTitulaire(true);
                        return;
            }
    };

    const handleIbanChange = (e) => {
        cursorPositionRef.current = e.target.selectionStart;
        const val = e.target.value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[!#$%&'*+/=?^{|}~"(),:;<>[\]\\@\d<>*!«»“”]/g, "");

        setId(val);


        if (!ribService.IsIbanTitulaireNomValid(val,usager)) {
            setCheckTitulaire(false);
        } else {
            setCheckTitulaire(true);
        }
    };

    useEffect(() => {
        if (inputRef.current && cursorPositionRef.current !== null) {
            inputRef.current.setSelectionRange(cursorPositionRef.current, cursorPositionRef.current);
        }
    }, [id]);

    return (
        <div className="formClap" style={{ marginTop: "1%" }}>
            <ChequeCultureLegacy />
            <Toast ref={toast} position="top-center" className="toast-position" />

            {true &&
            <div className="mx-auto">
                <div className="no_shadow_no_border card" style={{padding:0}}>
                    {(mapping &&
                    <form
                        action=""
                        id="espaceAgent"
                        method="POST"
                        name="formVacances"
                        className="form-horizontal cld-form-padding"
                    >

                <Accordion activeIndex={activeIndex} multiple onTabChange={(e) => setActiveIndex(e.index)}>
                     <AccordionTab header={<h3>Ma demande </h3>} disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">

                               <h4>Titulaire du compte</h4>
                                
                               { mode  === createMode &&
                                    <>
                                        
                                        { ibanNotFransh ?
                                            (
                                                <InputText 
                                                    value={"RIB ETRANGER"}
                                                    disabled={ibanNotFransh} 
                                                    style={{ width: '300px', marginRight: '5px' }} 
                                                />
                                            )
                                            :
                                            (
                                                <InputText 
                                                ref={inputRef}
                                                    value={id}
                                                    onChange={handleIbanChange}
                                                    disabled={ibanNotFransh} 
                                                    style={{ width: '300px', marginRight: '5px' }} 
                                                />
                                            
                                            )}
                                    </> 
                                }

                                { mode  === editMode &&
                                   <InputText  value={id} disabled={true}  style={{width:"20%"}}/>}
                                <p className="form-block-info">
                                     J’indique le titulaire mentionné sur mon relevé d’identité bancaire en respectant les règles mentionnées précédemment.
                                </p>
                                {!checkTitulaire && <p className="form-block-info"  style={{ color: 'red' }}>
                                      Le nom du titulaire du compte doit obligatoirement inclure le nom associé à votre numéro C.G.O.S qui doit également apparaitre sur le RIB justificatif
                                </p>}
                                
                                <br/>

                                <h4>Numéro IBAN</h4>
                                { mode  === createMode &&
                                <FieldBuilder code={'NEA_IBAN_TITULAIRE'} items={[mimeTypes, iban,null, true, null]} value={iban} onValueChange={(e) => setIban(e)}  disabled2={(e) => setDisabled2(e)}  disabled={ibanNotFransh}  isIbanValide={(e) => setIsIbanValide(e)}/>}
                                { mode  === editMode &&
                                   <InputText  value={iban} disabled={true} style={{width:"20%"}} />}
                                <p className="form-block-info">
                                    Je vérifie très attentivement les informations de mon IBAN pour être certain que les versements arriveront bien sur mon compte bancaire.
                                </p>

                                <br/>


                                { ((typeof iban === 'string' && iban.length >= 2 && (iban.substring(0, 2) !== "FR" && iban.substring(0, 2) !== "MC")) || ibanNotFransh) === true && (
                                    <>
                                        
                                        <div  style={{textAlign:"left"}}>
                                            <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", color:"red"}}>
                                                    <label>
                                                        <input type="checkbox" checked={ibanNotFransh} onChange={() => setIbanNotFransh(!ibanNotFransh)} style={{ marginRight: '10px' }} />
                                                        Si mon IBAN ne commence pas par FR ou MC, je coche obligatoirement cette case pour permettre son traitement.
                                                    </label>
                                            </span>
                                        </div>

                                    </>
                                )}
                                <br/><br/>
                                
                                { ibanNotFransh === true && (
                                <div className="alert alert-warning" style={{textAlign:"left"}}>
                                    <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                                        <p> 
                                            A l'étape <i>Justificatifs</i> vous devrez fournir un relevé d'identité bancaire avec votre Nom et votre numéro IBAN.

                                            <br/><br/>
                                            <b>Ce sont bien les informations de votre justificatif qui seront utilisées pour les versements de vos prestations.</b>
                                            <br/>Pour des raisons techniques les informations affichées ci-dessous seront celles qui apparaitront à la rubrique Références Bancaires de l'Espace Agent.
                                        </p>
                                    </span>
                                </div>
                                )}

                                { isIbanValide === false && (iban && iban.length == 27) &&(
                                    <div className="alert alert-danger" style={{textAlign:"left"}}>
                                    <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>
                                        <p> 
                                            <b>Numéro IBAN invalide</b>
                                            <br/><br/>
                                            Le code IBAN indiqué ne peut pas être utilisé (format invalide). Vérifiez s’il ne comporte pas une erreur.
                                        </p>
                                    </span>
                                    </div>
                                )}
                            </div>
                        </dl>


                        <dl className="dl-horizontal" style={{ display:'initial' }}>
                            <div className="form-block-wrapper" style={{ border: editMode === mode &&  (libelleJustifToDisplay.length >= 1) ? '3px solid red' : '', display : '' }}>                                                    
                                
                                {editMode === mode &&  (libelleJustifToDisplay.length >= 1) &&
                                    <div className="info-wrapper-2" style={{backgroundColor:'lightyellow', justifyContent:'left'}}>
                                        <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif"}}>
                                           {codeJustifToUploadList.includes(justificatifsIBAN[0].key) && <div>
                                                <h4 >Observations du C.G.O.S sur les documents déjà transmis</h4>

                                                {Object.entries(libelleJustifToDisplay).map(([key,val]) =>(
                                                    <li>{val}</li>
                                                ))}
                                           </div>}
                                            <br></br>

                                            <h4>Autre commentaire ou document complémentaire à nous envoyer :</h4>
                                            <p>{editFormData.noteRetourAgent}</p>

                                            <p>
                                                <h4>Merci de renvoyer dans ce formulaire, après correction, les documents indiqués ci-dessus (même nombre et mêmes types).</h4>
                                            </p>
                                        </span>
                                </div>}
                                
                                <h4>Je télécharge les documents justificatifs</h4>
                                {(createMode === mode ||  (editMode === mode && codeJustifToUploadList.includes(justificatifsIBAN[0].key))) &&
                                <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsIBAN, 10000000, true, null]} onValueChange={(e) => setJustificatifIban(e)} disabled={false} />
                                }
                                {(editMode === mode && editFormData?.siSupplementInfo) &&
                                <dl className="dl-horizontal" >
                                    <div className="form-block-wrapper">
                                    <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategoriesSupplement, 10000000, true, null,null]} onValueChange={(e) => setJustificatifSupplementInformations(e)} disabled={false} />
                                    </div>
                                </dl>}
                            </div>
                        </dl>

                       
                        {createMode === mode &&
                        <div className="next-button-wrapper">

                            <button type="button"
                                    className={ ( ((!(justificatifIban && justificatifIban.length > 0) || !(id && id.length > 1) || !(iban && iban.length == 27) || !isIbanValide)) && (!ibanNotFransh))
                                        ? "next-button button-arrow disabled"
                                        : "next-button button-arrow"}
                                    style={( ((!(justificatifIban && justificatifIban.length > 0) || !(id && id.length > 1) || !(iban && iban.length == 27) || !isIbanValide)) && (!ibanNotFransh))
                                        ? {pointerEvents: "none"}
                                        : {}}
                                    onClick={(e) => nextStep(e, 1)}
                                    disabled={( ((!(justificatifIban && justificatifIban.length > 0) || !(id && id.length > 1) || !(iban && iban.length == 27) || !isIbanValide))  && (!ibanNotFransh))} >
                                
                                Etape suivante
                            </button>                            
                        </div>}

                    </AccordionTab>
                        
                    <AccordionTab header={<h3> Signature et envoi de ma demande </h3>} disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-sign form-block-wrapper">
                                <div className="field-checkbox">
                                    <Checkbox inputId="sign1" checked={policyOne} onChange={e => setPolicyOne(e.checked)} />
                                    <label htmlFor="sign1">Je déclare sur l’honneur l’exactitude des informations concernant ma situation professionnelle, familiale et financière et je déclare être informé que quiconque se rend coupable de fraude, production de documents falsifiés comme justificatifs, fausses déclarations est passible des peines d’amendes et/ou d’emprisonnement.</label>
                                </div>
                                <div className="field-checkbox">
                                    <Checkbox inputId="sign2" checked={policyTwo} onChange={e => setPolicyTwo(e.checked)} />
                                    <label htmlFor="sign2">J’ai lu et j’approuve  la politique de gestion des données à caractère personnel renseignées dans ce formulaire.</label>
                                </div>
                                <div id="textarea" >
                                    <span>{text}</span>
                                     <br></br>
                                        <p>
                                    Pour en savoir plus, consultez la <a href='https://www.cgos.info/17/politique-protection-donnees' target='_blank'>page d'information sur la politique de protection des données du C.G.O.S.</a>
                                        </p>
                                </div>

                            </div>
                        </dl>

                        <div className="info-wrapper-2">
                            <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                Une fois votre demande traitée, vous recevrez une information par Email.
                                Vous pouvez également suivre son avancement depuis la rubrique{" "}
                                <a href={linkService.getRetourEaMembreSuiviDemande()}>Mes suivis{" "}</a>de votre Espace Agent.
                            </span>
                        </div>

                        <div className="form-group">
                            <div className="navButtons cld-submit-buttons">
                            <button className="btn invalide" type="button" style={{ backgroundColor: "#C9C9C9" }} name="RETOUR_PRESTATION" onClick={logoutRemoveData}>ANNULER</button>
                                { createMode == mode && <button className="btn" type="button" onClick={submitFormDemande} name="ENVOYER_MA_DEMANDE" disabled={disableSubmitCreate()}>Envoyer ma demande</button> }
                                { editMode == mode && <button className="btn" type="button" onClick={submitEditedDemande} name="ENVOYER_MA_DEMANDE" disabled={disableSubmitEdit()}>Envoyer ma demande</button> }
                            </div>
                        </div>
                   </AccordionTab>
                </Accordion>

                        <Dialog
                            closable={false}
                            header=""
                            visible={displayBasic}
                            modal
                            footer={basicDialogFooter}
                        >
                            <center>
                                <h2>
                                    Votre demande a bien été envoyée et sera étudiée prochainement. <br />{" "}
                                </h2>
                                <br />
                                <h4>
                                    Vous pouvez suivre son avancement depuis la rubrique{" "}
                                    <a href={linkService.getRetourEaMembreSuiviDemande()}><b>Mes suivis</b>{" "}</a>de votre Espace Agent.
                                </h4>
                                <br />
                            </center>
                        </Dialog>

                        <Dialog closable={false} header="" visible={showDemandeError} modal>
                            <center>
                                <h2>
                                    Un problème est survenu lors de l'envoi de votre demande de
                                    prestation : <b>{codeError}</b>
                                    <br />
                                </h2>
                                <br />
                                <h3>
                                    Pour renvoyer votre demande allez sur le formulaire de demande{" "}
                                </h3>
                                <br />
                                <br />
                                <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
                                <br />
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>

                        <Dialog
                            closable={false}
                            header=""
                            visible={showFileUploadError}
                            modal
                        >
                            <center>
                                <h2>
                                    Echec d'envoi de votre demande de changement de situation bancaire{" "}
                                    <br />
                                </h2>
                                <br />
                                <h3>
                                    En raison d’un problème technique : <b>{codeError}</b> les
                                    documents joints à votre demandes n’ont pas pu être
                                    enregistrés.
                                </h3>
                                <br />
                                <h3>
                                    Merci de nous renvoyer votre demande après vous être assuré
                                    que les documents joints à celle-ci sont conformes aux
                                    caractéristiques (taille, format) indiquées sur le formulaire.
                                </h3>
                                <br />
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>
                    </form>
                    )}
                </div>
            </div>}
        </div>
    );
};
